import DownArrowIcon from './downArrow.png'
import PfpIcon from './pfpIcon.svg'
import EditIcon from './editIcon.svg'
import Delicon from './delicon.svg'
import Plusicon from './delicon.png'
import cross from './circle-x-filled.png'

const Icons = {
    DownArrowIcon,
    PfpIcon,
    EditIcon,
    Delicon,
    Plusicon,
    cross
}

export default Icons